module.exports = __webpack_public_path__ + "static/img/number06.e4f391a8.png";